import { render, staticRenderFns } from "./NeedsPlate.vue?vue&type=template&id=2e48de9a&scoped=true&"
import script from "./NeedsPlate.vue?vue&type=script&lang=js&"
export * from "./NeedsPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48de9a",
  null
  
)

export default component.exports